
import Vue from "vue";
import store from "@/store";
import { convertFullDate } from "@/utils/date";
import AppLoading from "@/components/UI/AppLoading.vue";
import AppWarning from "@/components/UI/AppWarning.vue";
import { convertToPersian, separateDigits } from "@/utils/string";

export default Vue.extend({
  name: "TransactionsList",
  components: { AppLoading, AppWarning },
  data() {
    return {
      HeadersTable: [
        "ردیف",
        "عنوان",
        "موبایل کاربر",
        "نام ادمین",
        "مبلغ شارژ",
        "وضعیت",
        "تاریخ",
      ],
    };
  },
  methods: {
    convertFullDate,
    convertToPersian,
    separateDigits,
  },
  computed: {
    transactionsList() {
      return store.state.admin.transactionsList;
    },
  },
  created(): void {
    store.state.app.pageLoading = true;
    store.dispatch("admin/getTransactionsListPanelAdmin");
  },
});
